import { ApiModel, type ApiModelStructure } from '@composable-api/api.model'

interface Attributes {
    [DialCodeModel.ATTR_COUNTRY_ID]: string
    [DialCodeModel.ATTR_DIAL_CODE]: string
    [DialCodeModel.ATTR_COUNTRY_NAME]: string
    [DialCodeModel.ATTR_ALPHA2]: string
}

interface Embeds {
}

export class DialCodeModel extends ApiModel<Attributes, Embeds> {
    static key = 'DialCodeModel'

    static readonly ATTR_COUNTRY_ID = 'country_id'
    static readonly ATTR_DIAL_CODE = 'dial_code'
    static readonly ATTR_COUNTRY_NAME = 'country_name'
    static readonly ATTR_ALPHA2 = 'alpha2'

    get countryId() {
        return this._getAttribute(DialCodeModel.ATTR_COUNTRY_ID)
    }

    get dialCode() {
        return this._getAttribute(DialCodeModel.ATTR_DIAL_CODE)
    }

    get countryName() {
        return this._getAttribute(DialCodeModel.ATTR_COUNTRY_NAME)
    }

    get alpha2() {
        return this._getAttribute(DialCodeModel.ATTR_ALPHA2)
    }
}
